<template>
	<!-- 检查记录 0320版 -->
	<section>
		<!--工具条-->
		<el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
			<el-form :inline="true" :model="filters">
				<el-form-item  v-if="bquery">
					<el-input v-model="filters.companyName" placeholder="企业名称"></el-input>
				</el-form-item>
				<el-form-item>
					<el-input v-model="filters.checkTitle" placeholder="检查标题"></el-input>
				</el-form-item>
				<el-form-item >
					<el-button type="primary" v-on:click="getPageList">查询</el-button>
				</el-form-item>
				<el-form-item  v-if="bquery">
					<el-button type="success" v-on:click="showAddRecord">新增检查记录</el-button>
				</el-form-item>
			</el-form>
		</el-col>

		<!--列表--> 

		<el-table :data="pagelist" highlight-current-row v-loading="listLoading"  style="width: 100%;">
			<el-table-column prop="coName" label="企业名称" min-width="200" align="center">
			</el-table-column>
			<el-table-column prop="checkTitle" label="检查标题" align="center" min-width="200">
			</el-table-column>			
      		<el-table-column prop="checkDate" label="检查时间" align="center" min-width="120">
			</el-table-column>
      		<el-table-column prop="checkContent" label="检查内容" align="center"  min-width="200">
			</el-table-column>
			<el-table-column label="检查状态" align="center" min-width="100" >
				<template slot-scope="scope">
				<span>{{scope.row.checkStatus==='0'?'未整改':"已整改"}}</span>
				</template>
			</el-table-column>
			<el-table-column  label="操作" align="left" width="300">
				<template slot-scope="scope">					
					<el-button v-if="!bquery"  type="success" size="small" @click="handleEdit(scope.$index, scope.row)">整改</el-button>
					<el-button v-if="scope.row.checkURL!=''"  type="primary" size="small" @click="handleDownloadFile(scope.$index, scope.row)">下载检查材料</el-button>
				</template>
			</el-table-column>
		</el-table>

		<!--工具条-->
		<el-col :span="24" class="toolbar">
			<el-pagination layout="total,prev, pager, next" @current-change="handleCurrentChange" :page-size="20" :total="total" style="float:right;">
			</el-pagination>
		</el-col>

		<!--新增--> 
		<el-dialog title="新增检查记录" v-model="fileFormVisible" :close-on-click-modal="false" >
			<el-form :label-position="labelPosition" :model="fileForm" label-width="120px" :rules="fileFormRules" ref="fileForm">

				<el-form-item label="检查标题" prop="checkTitle">
					<el-input placeholder="请输入检查标题" v-model="fileForm.checkTitle" auto-complete="off"></el-input>
				</el-form-item>

				<el-form-item label="检查时间" prop="checkDate">
					<el-date-picker v-model="fileForm.selCheckDate" type="date" placeholder="选择日期" value-format="yyyy-MM-dd" format="yyyy-MM-dd"></el-date-picker>
				</el-form-item>

				<el-form-item label="检查内容" prop="checkContent">
					<el-input placeholder="请输入检查内容" v-model="fileForm.checkContent" auto-complete="off" type="textarea" :rows="2"></el-input>
				</el-form-item>

				<!-- 指定企业时，勾选表格（1显示） -->
				<el-form-item label="接收企业">
					<el-table ref="enterpriseTable" :data="enterpriseList" border style="width: 100%;" max-height="250" @selection-change="handleEnterpriseSelect">
						<el-table-column type="selection" width="55" />
						<el-table-column prop="coName" label="企业名称" />
						<!-- <el-table-column prop="coHeadName" label="企业编码" /> -->
					</el-table>
				</el-form-item>

				<el-form-item label="检查附件" >
					<div>
						<input  ref="upLoadRef" type="file" @change.stop="handleFileUpload">
						<button  v-show="uploadstart" @click.stop.prevent="uploadTrainFile">上传</button>
					</div>
				</el-form-item>
				如果有检查相关的文件或照片，请提前准备好并压缩成zip格式，再上传。
			</el-form>
						
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="fileFormVisible = false">取消</el-button>
				<el-button type="primary" @click.native="handlefile" :loading="fileLoading">保存</el-button>
			</div>
		</el-dialog>
		
		<!--整改页面-->
		<el-dialog title="整改信息" v-model="editFormVisible" :close-on-click-modal="false">
			
			<el-form :model="editForm" label-width="100px" :rules="editFormRules" ref="editForm">
				<el-form-item label="整改时间" prop="correctDate">
					<el-date-picker v-model="editForm.selCorrectDate" type="date" placeholder="选择日期" value-format="yyyy-MM-dd" format="yyyy-MM-dd"></el-date-picker>
				</el-form-item>

				<el-form-item label="整改说明" prop="correctContent">
					<el-input placeholder="请输入整改说明" v-model="editForm.correctContent" auto-complete="off" type="textarea" :rows="2"></el-input>
				</el-form-item>

				<el-form-item label="检查附件" >
					<div>
						<input  ref="upLoadRef1" type="file" @change.stop="handleFileUpload1">
						<button  v-show="uploadstart1" @click.stop.prevent="uploadTrainFile1">上传</button>
					</div>
				</el-form-item>
				如果有整改相关的文件或照片，请提前准备好并压缩成zip格式，再上传。
			</el-form>

			<div slot="footer" class="dialog-footer">
				<el-button @click.native="editFormVisible = false">取消</el-button>
				<el-button type="primary" @click.native="editGovCheckRecord" :loading="editLoading">保存</el-button>
			</div>
		</el-dialog>

	</section>
</template>

<script>
	import axios from 'axios';
	import { govCheckPageList,addGovCheck,updateGovCheckInfo,allCompanyList} from '../../api/api';

	export default {
		data() {
			return {
				objectId:0, //当前登录的用户id，新增会用到
				coId:0, //当前登录的用户企业id
				bquery:false,//管理员权限
				filters: {
					companyName: '',
					checkTitle:''
				},
				pagelist: [],
				total: 0,
				page: 1,
				listLoading: false,
				labelPosition: 'right',
				enterpriseList: [], // 企业列表（从后端接口获取）

				//上传附件
				uploadstart:true,
				fcfile: null,

				//新增
				fileFormVisible: false, 
				fileLoading: false,
				fileFormRules: {
					checkTitle: [{ required: true, message: "请输入检查标题", trigger: "blur" }],
					checkContent: [{ required: true, message: "请输入检查内容", trigger: "blur" }],
					checkDate: [{ required: true, message: "请选择检查时间", trigger: "blur" }],
				},
				
				fileForm: {
					createUserId:0,
					enterpriseIds: [], // 存储勾选的企业ID

					checkTitle:"",
					checkContent:"",
					checkDate:"",
					selCheckDate:null,

					checkURL:"",
				},
				
				uploadstart1:true,
				fcfile1: null,

				//编辑信息
				editFormVisible: false, 
				editLoading: false,
				editFormRules: {
					correctContent: [{ required: true, message: "请输入整改说明", trigger: "blur" }],
					correctDate: [{ required: true, message: "请选择整改时间", trigger: "blur" }],
				},
				
				editForm: {
					govcheckId:'',
					correctContent:'',
					correctDate:"",
					checkStatus:"1",
					selCorrectDate:null,

					correctURL:""
				},
			}
		},
		methods: {
			handleDownloadFile: function (index, row) {
				if(row.checkURL!=""){
					let zipurl="https://aqjg.ycsyzglj.com/"+row.checkURL
					let a = document.createElement("a");//创建a标签
					a.setAttribute("href", zipurl);//设置文件下载地址
					a.setAttribute('target', '_blank');//在当前页面创建下载
					document.body.appendChild(a);//添加到body
					a.click();//触发事件
					document.body.removeChild(a);//移除标签
				}
			},
			handleCurrentChange(val) {				
				this.page = val;
				this.getPageList();
			},
			//获取分页列表
			getPageList() {
				let para = {
					page: this.page,
					pageSize:20,
					coName: this.filters.companyName,
					coId:this.coId,
					objectId:this.objectId,
					checkTitle: this.filters.checkTitle,
					checkStatus:"0"
				};

				this.listLoading = true;

				govCheckPageList(para).then((res) => {
					if(res.data.code==0){
						this.total = res.data.data.total;
						this.pagelist = res.data.data.list;
					}
					
					this.listLoading = false;

				});
			},
			//获取全部客户列表
			getAllcompanyList() {
				let para = {
					objectId:this.objectId
				};
		
				allCompanyList(para).then((res) => {
					if(res.data.code==0){
						this.enterpriseList = res.data.data;
					}
				});
			},
			// 勾选指定企业：记录企业ID
			handleEnterpriseSelect(selection) {
				this.fileForm.enterpriseIds = selection.map(item => item.coId)
			},
			showAddRecord: function (index, row) {
				if(this.enterpriseList.length==0){
					this.$message.error("请先创建企业");
				}else{
					this.fileFormVisible = true;
									
	
					this.fileForm.createUserId=this.objectId

					this.fileForm.checkTitle=""
					this.fileForm.checkContent=""
					this.fileForm.checkDate=""
					this.fileForm.selCheckDate=null		

					this.fileForm.checkURL=""
					this.fcfile = null;
					this.uploadstart=true
					if (this.$refs.upLoadRef) {
						this.$refs.upLoadRef.value = '' // 置空input文件
					}
	  				
				}		
			},
			handlefile: function () {
				if (this.fileForm.enterpriseIds.length==0) {
					this.$message.error("请选择整改企业");
				} else {
					if(this.fileForm.selCheckDate!=null){
						this.fileForm.checkDate = this.fileForm.selCheckDate.toLocaleString();
					}
					this.$refs.fileForm.validate((valid) => {
						if (valid) {
							this.$confirm('确认提交检查记录吗？', '提示', {}).then(() => {
								this.fileLoading = true;
								addGovCheck(this.fileForm).then((res) => {
									this.fileLoading = false;

									// 1. 清空选中数组
									this.fileForm.enterpriseIds = [];
				
									// 2. 关键！清空表格勾选状态（必须加）
									this.$refs.enterpriseTable.clearSelection();

									this.fileFormVisible = false;
									if(res.data.code==0){
										this.$message.success(res.data.message);
										this.getPageList();
									}
									else{
										this.$message.error(res.data.message);
									}
								});
							});
						}
					});
				}
							
			},
			handleFileUpload(event) {
				let filearr = event.target.files[0].name.split('.');

				if(filearr[1]=='zip'){
					this.fcfile = event.target.files[0];
				}else{
					this.fcfile = null;
					this.$message.error("请选择zip格式的文件");
				}
				
			},
			uploadTrainFile() {
				if(this.fcfile!=null){
					let formData = new FormData();
					formData.append('file', this.fcfile);
					formData.append('filetype', "Yhpczl");
					formData.append('secondarydir', "gov_r_"+this.objectId);
					axios.post('/yhpczl/mgr/v1/uploadFile', formData, {
						headers: {
						'Content-Type': 'multipart/form-data'
						}
					}).then(response => {					
						if (response.data.code==0) {
							this.fileForm.checkURL = response.data.data.url;
							this.uploadstart=false
							this.$message.success("文件上传成功，请填写其他信息后点击保存");
						} else {
							this.$message.error("文件上传失败，请重新提交");
						}
					});
				}else{
					this.$message.error("请选择文件后再点击【上传】按钮");
				}
				
			},	
			handleFileUpload1(event) {
				let filearr = event.target.files[0].name.split('.');

				if(filearr[1]=='zip'){
					this.fcfile1 = event.target.files[0];
				}else{
					this.fcfile1 = null;
					this.$message.error("请选择zip格式的文件");
				}
				
			},
			uploadTrainFile1() {
				if(this.fcfile1!=null){
					let formData = new FormData();
					formData.append('file', this.fcfile1);
					formData.append('filetype', "Yhpczl");
					formData.append('secondarydir', "gov_c_"+this.objectId);
					axios.post('/yhpczl/mgr/v1/uploadFile', formData, {
						headers: {
						'Content-Type': 'multipart/form-data'
						}
					}).then(response => {					
						if (response.data.code==0) {
							this.editForm.correctURL = response.data.data.url;
							this.uploadstart1=false
							this.$message.success("文件上传成功，请填写其他信息后点击保存");
						} else {
							this.$message.error("文件上传失败，请重新提交");
						}
					});
				}else{
					this.$message.error("请选择文件后再点击【上传】按钮");
				}
				
			},	
			handleEdit: function (index, row) {
				this.editForm.govcheckId =row.govcheckId

				this.editForm.correctContent=""
				this.editForm.correctDate=""
				this.editForm.selCorrectDate=null		
				
				this.editForm.checkStatus="1"

				this.editForm.correctURL=""
				this.fcfile1 = null;
				this.uploadstart1=true
				if (this.$refs.upLoadRef1) {
					this.$refs.upLoadRef1.value = '' // 置空input文件
				}
				this.editFormVisible=true
			},
			
			//企业编辑整改信息
			editGovCheckRecord: function () {
				if(this.editForm.selCorrectDate!=null){
					this.editForm.correctDate = this.editForm.selCorrectDate.toLocaleString();
				}

				this.$refs.editForm.validate((valid) => {
					if (valid) {
						this.$confirm('确认提交吗？', '提示', {}).then(() => {
							this.editLoading = true;
						
							updateGovCheckInfo(this.editForm).then((res) => {
								this.editLoading = false;
								this.editFormVisible = false;
								if(res.data.code==0){
									this.$message.success(res.data.message);
									this.getPageList();
								}
								else{
									this.$message.error(res.data.message);
								}

							});
						});
						
					}
				});
			},
		},
		mounted() {			
			let user = JSON.parse(sessionStorage.getItem('user'));
			this.objectId = user.data.userId
			this.coId = user.data.coId

			if (user.data.roleId=="4") {
				this.filters.companyName = user.data.userName	
				this.bquery=false
			} else {
				this.bquery=true
				this.getAllcompanyList();
			}

			this.getPageList();

		}
	}

</script>

<style scoped>
	
	
</style>


// WEBPACK FOOTER //
// govCheckRecord.vue?3611bb0a